
import { z } from "zod";

export const TicketPriorityValues = ["NONE", "LOW", "MEDIUM", "HIGH", "URGENT"] as const;
export const TicketPrioritySchema = /* @__PURE__ */ z.enum(TicketPriorityValues);
export const TicketPriority: (typeof TicketPrioritySchema)["enum"] = { "NONE": "NONE", "LOW": "LOW", "MEDIUM": "MEDIUM", "HIGH": "HIGH", "URGENT": "URGENT" };
export type TicketPriority = (typeof TicketPriorityValues)[number];
export const TicketPriorityDisplayNames = { "NONE": "None",
"LOW": "Low",
"MEDIUM": "Medium",
"HIGH": "High",
"URGENT": "Urgent", } satisfies Record<TicketPriority, string>;
